<div class="modal-base" *ngIf="_isModalOpen">
	<section
		class="modal-base__content"
		[style]="{ '--justify-content': currentPosition }"
		[@modal]="_isModalOpen ? 'visible' : 'hidden'">
		<ng-content></ng-content>
	</section>
</div>
